import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { useTestCompletionCapability } from '@/hooks/coaching/useTestCompletion'

interface Props {
  children: React.ReactNode
  /** Where non-TEST centers land instead; the existing Today's Class page by default. */
  fallbackPath?: string
}

/**
 * Pages still being trialled run only in TEST centers (`organizations.lc_operation_mode = TEST`).
 * Production centers, and any failure to confirm the mode, fall back to the existing page.
 */
export function TestCenterGuard({ children, fallbackPath = '/admin/coaching' }: Props) {
  const { t } = useTranslation('coaching')
  const capability = useTestCompletionCapability()

  if (capability.isPending) return <div role="status" className="p-6 text-sm text-muted-foreground">{t('dashboard.loading')}</div>
  if (capability.data?.operationMode !== 'TEST') return <Navigate to={fallbackPath} replace />
  return <>{children}</>
}
